import _ from 'underscore';

import { CheckboxState } from '../../../common/components/checkboxes/CheckboxState';
import { ISiteNameWithId } from '../../../ts/ServerApi/types/ISiteNameWithId';
import { SiteMembershipDialogFilters, SiteRolesPickerContainerState } from '../SiteRolesPickerContainer';

export class SiteRolesPickerFiltersHelper {
    /**
     *
     * @param state
     * @param searchInput
     * Set search input and save current filter
     */
    public static getStateOnTextChange(state: SiteRolesPickerContainerState, siteSearchQuery: string): SiteRolesPickerContainerState {
        let lastSiteFilter = state.lastSiteFilter;
        if (state.currentSiteFilter !== SiteMembershipDialogFilters.SearchResults) {
            lastSiteFilter = state.currentSiteFilter;
        }
        return {...state, siteSearchQuery, lastSiteFilter};
    }

    /**
     * @param state
     * clear search iniput and restore last filter
     */
    public static getStateOnCancelSearch(state: SiteRolesPickerContainerState): SiteRolesPickerContainerState {
        let siteSearchQuery = '';
        let currentSiteFilter = state.currentSiteFilter;
        if (currentSiteFilter === SiteMembershipDialogFilters.SearchResults) {
            currentSiteFilter = state.lastSiteFilter;
        }
        return{...state, currentSiteFilter, siteSearchQuery};
    }

    /**
     * @param state
     * Get all sites and don't have search results in site filters options
     */
    public static getStateForAllSitesFilter(state: SiteRolesPickerContainerState): SiteRolesPickerContainerState {
        let siteNamesWithFilter;
        let availableSiteFilters;
        let currentSiteFilter;

        siteNamesWithFilter = state.siteNames;
        currentSiteFilter = SiteMembershipDialogFilters.AllSites;
        availableSiteFilters = [SiteMembershipDialogFilters.AllSites,SiteMembershipDialogFilters.AssignedSites];
        return {...state, siteNamesWithFilter, currentSiteFilter, availableSiteFilters};
    }

    /**
     * @param state
     * Get sites that have checkbox checked
     */
    public static getStateForAssignedSitesFilter(state: SiteRolesPickerContainerState): SiteRolesPickerContainerState {
        let siteNamesWithFilter;
        let availableSiteFilters;
        let currentSiteFilter;

        siteNamesWithFilter = _.filter(state.siteNames, (site: ISiteNameWithId) => state.siteRowCheckboxPropMap[site.id].checkboxState !== CheckboxState.empty);
        currentSiteFilter = SiteMembershipDialogFilters.AssignedSites;
        availableSiteFilters = [SiteMembershipDialogFilters.AllSites,SiteMembershipDialogFilters.AssignedSites];
        return {...state, siteNamesWithFilter, currentSiteFilter, availableSiteFilters};
    }

    /**
     * @param state
     * Get site names based on search input and put search results in site filter option
     */
    public static getStateForSearchResultsFilter(state: SiteRolesPickerContainerState, searchResults: ISiteNameWithId[]): SiteRolesPickerContainerState {
        let siteNamesWithFilter;
        let availableSiteFilters;
        let currentSiteFilter;

        siteNamesWithFilter = searchResults;
        currentSiteFilter = SiteMembershipDialogFilters.SearchResults;
        availableSiteFilters = [SiteMembershipDialogFilters.AllSites,SiteMembershipDialogFilters.AssignedSites,SiteMembershipDialogFilters.SearchResults];

        return {...state, siteNamesWithFilter, currentSiteFilter, availableSiteFilters};
    }
  }
